let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hUIij"), load("6Up0b"), load("lnKog")]).then(() => parcelRequire('2mcHd'));